import { render, staticRenderFns } from "./Infomain.vue?vue&type=template&id=ef6bfdb0&scoped=true"
import script from "./Infomain.vue?vue&type=script&lang=js"
export * from "./Infomain.vue?vue&type=script&lang=js"
import style0 from "./Infomain.vue?vue&type=style&index=0&id=ef6bfdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6bfdb0",
  null
  
)

export default component.exports